module.exports = __webpack_public_path__ + "static/media/image5.ccc33e05.jpg";